function Mongolia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_1668)">
  <path d="M16 32C17.9571 32 19.8319 31.648 21.5652 31.0048L22.2609 16L21.5653 0.995188C19.8319 0.352063 17.9571 0 16 0C14.0429 0 12.1681 0.352063 10.4348 0.995188L9.73914 16L10.4348 31.0048C12.1681 31.648 14.0429 32 16 32Z" fill="#0052B4"/>
  <path d="M0 15.9999C0 22.8794 4.342 28.7441 10.4348 31.0047V0.995117C4.342 3.2558 0 9.12049 0 15.9999Z" fill="#A2001D"/>
  <path d="M21.5652 0.995117V31.0048C27.658 28.7441 32 22.8794 32 15.9999C32 9.12049 27.658 3.2558 21.5652 0.995117Z" fill="#A2001D"/>
  <path d="M7.65222 16H9.04353V21.5652H7.65222V16Z" fill="#FFDA44"/>
  <path d="M2.08691 16H3.47823V21.5652H2.08691V16Z" fill="#FFDA44"/>
  <path d="M5.56514 19.4779C6.33354 19.4779 6.95645 18.855 6.95645 18.0866C6.95645 17.3182 6.33354 16.6953 5.56514 16.6953C4.79674 16.6953 4.17383 17.3182 4.17383 18.0866C4.17383 18.855 4.79674 19.4779 5.56514 19.4779Z" fill="#FFDA44"/>
  <path d="M5.56513 13.9127C5.94931 13.9127 6.26076 13.6013 6.26076 13.2171C6.26076 12.8329 5.94931 12.5215 5.56513 12.5215C5.18095 12.5215 4.86951 12.8329 4.86951 13.2171C4.86951 13.6013 5.18095 13.9127 5.56513 13.9127Z" fill="#FFDA44"/>
  <path d="M4.17395 20.1738H6.95658V21.5651H4.17395V20.1738Z" fill="#FFDA44"/>
  <path d="M4.17395 14.6084H6.95658V15.9997H4.17395V14.6084Z" fill="#FFDA44"/>
  <path d="M5.56521 8.34766L6.05796 9.86391H7.65221L6.36252 10.801L6.8549 12.3173L5.56521 11.3802L4.27558 12.3173L4.76796 10.801L3.47827 9.86391H5.07252L5.56521 8.34766Z" fill="#FFDA44"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Mongolia;
